/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const pdfInvoices = {
  pdfContas: {
    featureNotEnabled:
      'Se você não conseguir obter faturas, certifique-se de que SAP Fatura e API para faturas estejam ativados.',
    invoicesLoadingError:
      'Algo deu errado. Não é possível exibir faturas de pedidos',
    invoicesTable: {
      header: 'Contas',
      label: 'Contas Table',
      invoiceId: 'Fatura #',
      createdAt: 'Data',
      netAmount: 'Montante líquido',
      totalAmount: 'Montante total',
      attachment: 'Baixar fatura',
      download: 'Baixar',
      attachmentDescription: 'Baixe o PDF para fatura {{id}}.',
      noneFound: 'Nenhuma fatura encontrada',
    },
    downloadPDFError: 'Algo deu errado. O PDF da fatura não pode ser obtido.',
    sortBy: 'Classificar por',
    sortContas: 'Classificar faturas',
    sorts: {
      byCreatedAtAsc: 'Dados crescentes',
      byCreatedAtDesc: 'Data decrescente',
      byInvoiceIdAsc: 'Número da fatura upstream',
      byInvoiceIdDesc: 'Número da fatura downstream',
      byNetAmountAsc: 'Líquido ascendente vertical',
      byNetAmountDesc: 'Líquido Descendente Vertical',
      byTotalAmountAsc: 'Vertical Ascendente Total',
      byTotalAmountDesc: 'Montante total Descendente',
    },
  },
};
